export class PaymentOptionModel {
    paymentTypeId?: number;
    amount?: number;
    commissionAmount?: number;
}
